var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-input" },
    [
      _c(
        "el-autocomplete",
        {
          staticClass: "inline-input",
          attrs: {
            "popper-append-to-body": false,
            "fetch-suggestions": _vm.querySearchAsync,
            "trigger-on-focus": false,
            placeholder: "搜索影片名",
          },
          on: { select: _vm.handleSearchSelect },
          model: {
            value: _vm.searchInfo,
            callback: function ($$v) {
              _vm.searchInfo = $$v
            },
            expression: "searchInfo",
          },
        },
        [
          _c("i", {
            staticClass: "el-icon-search el-input__icon",
            attrs: { slot: "prefix" },
            slot: "prefix",
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }